// components/AnalysisDisplayContainer.jsx (Modernized)
import React, { useContext } from 'react';
import AnalysisDisplay from './AnalysisDisplay';
import { MemoModalProvider } from './modal/MemoModalProvider';
import TranscriptCodePageContainer from './TranscriptCodePageContainer';
import CodeOperationsContext from 'contexts/CodeOperationsContext';
import RequiresExcerptsOnboardingWrapper from './RequiresExcerptsOnboardingWrapper';
import { useProjectWithErrorHandling } from 'hooks/projects/useProjectWithErrorHandling';
import snippetsImage from 'images/onboarding/onboarding_snippets.png';

function AnalysisDisplayContainer({
  projectID,
  hasEditPermission,
  onboardingState
}) {
  // Check if project exists and handle 404
  const { NotFoundComponent } = useProjectWithErrorHandling(projectID);
  const { onExcerptSelected } = useContext(CodeOperationsContext);

  if (NotFoundComponent) {
    return <NotFoundComponent />;
  }

  return (
    <RequiresExcerptsOnboardingWrapper
      loaded={onboardingState.loaded}
      showOnboarding={onboardingState.hasNoCodeableData}
      hasExcerpts={onboardingState.hasExcerpts}
      hasEditPermission={hasEditPermission}
      projectID={projectID}
      header="Uncover themes and patterns"
      body="First, code a transcript"
      mediaType="image"
      mediaSrc={snippetsImage}
    >
      <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
        <MemoModalProvider>
          <TranscriptCodePageContainer
            projectID={projectID}
            hasEditPermission={hasEditPermission}
          />
          <AnalysisDisplay
            onExcerptClicked={onExcerptSelected}
            hasEditPermission={hasEditPermission}
                  projectID={projectID}
          />
        </MemoModalProvider>
      </div>
    </RequiresExcerptsOnboardingWrapper>
  );
}

export default AnalysisDisplayContainer;